import { render, staticRenderFns } from "./RedFlagGuard.vue?vue&type=template&id=28a57ca3&scoped=true&"
import script from "./RedFlagGuard.vue?vue&type=script&lang=js&"
export * from "./RedFlagGuard.vue?vue&type=script&lang=js&"
import style0 from "./RedFlagGuard.vue?vue&type=style&index=0&id=28a57ca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a57ca3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a57ca3')) {
      api.createRecord('28a57ca3', component.options)
    } else {
      api.reload('28a57ca3', component.options)
    }
    module.hot.accept("./RedFlagGuard.vue?vue&type=template&id=28a57ca3&scoped=true&", function () {
      api.rerender('28a57ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/RedFlagGuard.vue"
export default component.exports